const EXPERIENCE_DATE_FROM_SET = 'EXPERIENCE_DATE_FROM_SET';
const EXPERIENCE_DATE_FROM_SET_VALIDATION_MESSAGE = 'EXPERIENCE_DATE_FROM_SET_VALIDATION_MESSAGE';
const EXPERIENCE_DATE_FROM_SET_VISUALIZATION = 'EXPERIENCE_DATE_FROM_SET_VISUALIZATION';
const EXPERIENCE_DATE_FROM_SET_API_ERROR = 'EXPERIENCE_DATE_FROM_SET_API_ERROR';
const EXPERIENCE_DATE_FROM_SET_FOCUS = 'EXPERIENCE_DATE_FROM_SET_FOCUS';
const EXPERIENCE_DATE_FROM_BLURRED = 'EXPERIENCE_DATE_FROM_BLURRED';
const EXPERIENCE_DATE_FROM_FOCUSED = 'EXPERIENCE_DATE_FROM_FOCUSED';
const EXPERIENCE_DATE_FROM_CHANGE = 'EXPERIENCE_DATE_FROM_CHANGE';
const SET_VALIDITY = 'EXPERIENCE_DATE_FROM_SET_VALIDITY';

const experienceDateFromSet = (value, date) => ({
  type: EXPERIENCE_DATE_FROM_SET,
  payload: {
    value,
    date
  }
});

const experienceDateFromSetValidationMessage = (validationMessage) => ({
  type: EXPERIENCE_DATE_FROM_SET_VALIDATION_MESSAGE,
  payload: {
    validationMessage
  }
});

const experienceDateFromSetVisualization = (markedAsWrong) => ({
  type: EXPERIENCE_DATE_FROM_SET_VISUALIZATION,
  payload: {
    markedAsWrong
  }
});

const experienceDateFromSetApiError = (payload) => ({
  type: EXPERIENCE_DATE_FROM_SET_VISUALIZATION,
  payload
});

const experienceDateFromSetFocus = (focus) => ({
  type: EXPERIENCE_DATE_FROM_SET_FOCUS,
  payload: {
    focus
  }
});

// eslint-disable-next-line max-params
const experienceDateFromBlur = (validationMessage, date, dateTo, stillWorking) => ({
  type: EXPERIENCE_DATE_FROM_BLURRED,
  payload: {
    validationMessage,
    date,
    dateTo,
    stillWorking
  }
});

const experienceDateFromFocus = (payload) => ({
  type: EXPERIENCE_DATE_FROM_FOCUSED,
  payload
});

const experienceDateFromChange = (payload) => ({
  type: EXPERIENCE_DATE_FROM_CHANGE,
  payload
});


const experienceDateFromSetValidity = (valid) => ({
  type: SET_VALIDITY,
  payload: {
    valid
  }
});


export {
  experienceDateFromSetValidationMessage,
  experienceDateFromSetVisualization,
  experienceDateFromFocus,
  experienceDateFromSetFocus,
  experienceDateFromSetApiError,
  experienceDateFromBlur,
  experienceDateFromSet,
  experienceDateFromChange,
  experienceDateFromSetValidity,
  SET_VALIDITY,
  EXPERIENCE_DATE_FROM_CHANGE,
  EXPERIENCE_DATE_FROM_FOCUSED,
  EXPERIENCE_DATE_FROM_BLURRED,
  EXPERIENCE_DATE_FROM_SET_FOCUS,
  EXPERIENCE_DATE_FROM_SET_API_ERROR,
  EXPERIENCE_DATE_FROM_SET_VALIDATION_MESSAGE,
  EXPERIENCE_DATE_FROM_SET,
  EXPERIENCE_DATE_FROM_SET_VISUALIZATION
};

